import { useState } from 'react';
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { RefreshCw } from 'lucide-react';

export const CurrencyConverter = () => {
  const [amount, setAmount] = useState('');
  const [fromCurrency, setFromCurrency] = useState('USD');
  const [toCurrency, setToCurrency] = useState('INR');
  const [result, setResult] = useState<number | null>(null);

  const handleConvert = () => {
    // For demo purposes using static conversion rates
    // In production, you would use a real currency API
    const rates = {
      USD: { INR: 83.12, EUR: 0.92 },
      INR: { USD: 0.012, EUR: 0.011 },
      EUR: { USD: 1.09, INR: 90.45 }
    };

    const convertedAmount = Number(amount) * rates[fromCurrency as keyof typeof rates][toCurrency as keyof typeof rates[keyof typeof rates]];
    setResult(convertedAmount);
  };

  return (
    <Card className="p-4 bg-gradient-to-br from-green-50 to-green-100">
      <h3 className="text-lg font-semibold mb-4">Currency Converter</h3>
      <div className="space-y-4">
        <Input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <div className="flex gap-2">
          <Select value={fromCurrency} onValueChange={setFromCurrency}>
            <SelectTrigger>
              <SelectValue placeholder="From" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="USD">USD</SelectItem>
              <SelectItem value="INR">INR</SelectItem>
              <SelectItem value="EUR">EUR</SelectItem>
            </SelectContent>
          </Select>
          <Select value={toCurrency} onValueChange={setToCurrency}>
            <SelectTrigger>
              <SelectValue placeholder="To" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="USD">USD</SelectItem>
              <SelectItem value="INR">INR</SelectItem>
              <SelectItem value="EUR">EUR</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <Button onClick={handleConvert} className="w-full">
          <RefreshCw className="h-4 w-4 mr-2" />
          Convert
        </Button>
        {result && (
          <div className="text-center font-semibold">
            {result.toFixed(2)} {toCurrency}
          </div>
        )}
      </div>
    </Card>
  );
};